import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './CardContentWrapper.module.css';

type CardContentWrapperProps = HTMLAttributes<HTMLDivElement>;

const CardContentWrapper: FC<CardContentWrapperProps> = ({ className, ...props }) => (
  <div className={clsx(s.wrapper, className)} {...props} />
);

export { CardContentWrapper };
